(function(register){
    if (document.readyState !== 'loading') {
        register();
    } else {
        document.addEventListener('DOMContentLoaded', register, {
            once: true,
            passive: true,
        });
    }
})(function() {
    console.warn("the base-popup custom element has been deprecated in favor of the native dialog element, please migrate");
    if (customElements.get('base-popup') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
            --popup-backdrop-color: black;
            --popup-backdrop-opacity: .625;
            --popup-padding: 1rem;
        
            position: fixed;
            inset: 0;
            pointer-events: none;
            z-index: 110;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: var(--popup-padding);
        }
        :host([size="fullscreen"]) {
            --popup-padding: 0rem;
        }
        :host([position*="left"]) {
            justify-content: flex-start;
        }
        :host([position*="right"]) {
            justify-content: flex-end;
        }
        :host([position*="top"]) {
            align-items: flex-start;
        }
        :host([position*="bottom"]) {
            align-items: flex-end;
        }
        :host([position*="stretch-width"]) [part="content"] {
            flex-grow: 1;
        }
        :host([position*="stretch-height"]) {
            align-items: stretch;
        }
        /* needs further implementation support because we cant influence the childs flex-grow property */
        :host([position*="stretch-height"]) [part="content"],
        :host([size="fullscreen"]) [part="content"] {
            display: flex;
            flex-direction: column;
            align-items: stretch;
        }
        [part="backdrop"] {
            display: block;
            position: absolute;
            inset: 0;
            z-index: 0;
            background: var(--popup-backdrop-color);
            opacity: var(--popup-backdrop-opacity);
            pointer-events: all;
        }
        [part="close-button"] {
            appearance: none;
            background: transparent;
            padding: 0;
            height: auto;
            width: auto;
            color: inherit;
            position: absolute;
            border: 0;
            outline: 0;
            right: 0;
            top: 0;
            z-index: 2;
            pointer-events: all;
        }
        [part="close-button"]:is(:focus-visible) {
            outline: 2px solid currentColor;
            outline-offset: -2px;
        }
        :host([disable-close-button]:not([disable-close-button="0"],[disable-close-button="false"])) [part="close-button"],
        :host([disable-close]:not([disable-close="0"],[disable-close="false"])) [part="close-button"] {
            display: none!important;
        }
        [part="default-close-button"]::before {
            content: "×";
            font-size: 1.5rem;
            display: inline-block;
            padding: .25em .5em;
            font-weight: bold;
            font-family: 'Arial', sans-serif;
            opacity: .5;
        }
        :host([disable-backdrop]:not([disable-backdrop="0"],[disable-backdrop="false"])) {
            pointer-events: none;
        }
        :host([disable-backdrop]:not([disable-backdrop="0"],[disable-backdrop="false"])) [part="backdrop"] {
            display: none;
        }
        [part="content"] {
            position: relative;
            z-index: 1;
            pointer-events: all;
            max-width: calc(100% - var(--popup-padding));
            max-height: calc(100% - var(--popup-padding));
            overflow: auto;
        }
        [part="content"]::before,
        [part="content"]::after {
            content: "";
            display: block;
        }
        :host([size="tiny"]) [part="content"] {
            width: 240px;
        }
        :host([size="xsmall"]) [part="content"] {
            width: 320px;
        }
        :host([size="small"]) [part="content"] {
            width: 480px;
        }
        :host([size="medium"]) [part="content"] {
            width: 640px;
        }
        :host([size="large"]) [part="content"] {
            width: 800px;
        }
        :host([size="xlarge"]) [part="content"] {
            width: 1024px;
        }
        :host([size="fullscreen"]) [part="content"] {
            min-width: 100dvw;
            min-height: 100dvh;
        }
        </style>
        <div part="backdrop"></div>
        <div part="content">
            <button part="close-button">
                <slot name="close-button">
                    <span part="default-close-button"></span>        
                </slot>
            </button>
            <slot></slot>
        </div>
        `;
        customElements.define('base-popup', class extends HTMLElement {
            static get observedAttributes() {
                return ['open'];
            }
            get closeable() {
                return (
                    this.hasAttribute('disable-close') === false
                    || this.getAttribute('disable-close') === '0'
                    || this.getAttribute('disable-close') === 'false'
                );
            }
            get closeElement() {
                if (!this.closeable) {
                    return null;
                }
                return this.shadowRoot.querySelector('[part="close-button"]');
            }
            constructor() {
                super();
                this.attachShadow({mode: 'open'}).appendChild(template.content.cloneNode(true));
                this.render();
                // necessary to avoid binding the listener function to the event target
                this.keyupListener = this.keyupListener.bind(this);
            }
            attributeChangedCallback(name, oldVal, newVal) {
                if (oldVal !== newVal) {
                    this.render();
                }
            }
            keyupListener(event) {
                if (event.key === "Escape") {
                    this.close();
                }
            }
            render() {
                if (this.hasAttribute('open')) {
                    this.shadowRoot.innerHTML = template.innerHTML;
                    if (this.closeable) {
                        this.shadowRoot.querySelector('[part="backdrop"]').addEventListener('click', this.close.bind(this));
                        this.shadowRoot.querySelector('[part="close-button"]').addEventListener('click', this.close.bind(this));
                        window.addEventListener('keyup', this.keyupListener, {capture: true});
                    }
                } else {
                    this.shadowRoot.innerHTML = '';
                    if (this.closeable) {
                        window.removeEventListener('keyup', this.keyupListener, {capture: true});
                    }
                }
            }
            open() {
                // @experimental this implementation is too static
                if (this.hasAttribute('disable-body-scroll')) {
                    const styleHack = document.createElement('style');
                    styleHack.innerHTML = `
                    html {overflow: hidden!important}
                    `;
                    document.querySelector('head').insertAdjacentElement('beforeend', styleHack);
                    this.addEventListener('close', () => {
                        styleHack.parentElement.removeChild(styleHack);
                    }, {
                        passive: true,
                        once: true,
                    });
                }
                this.setAttribute('open', 'open');
                this.render();
                this.dispatchEvent(new CustomEvent('open', {bubbles: false, cancelable: false}));
                if (this.tabIndex !== -1) {
                    this.focus();
                }
                // if backdrop is enabled, disable tabindex for all elements except the popup
                if(!this.hasAttribute("disable-backdrop") || this.getAttribute("disable-backdrop" == false)) {
                    document.dispatchEvent(new CustomEvent('a11y.toggletabindex', {
                        detail: {disable: document.body, enable: this}
                    }));
                }
            }
            close() {
                this.removeAttribute('open');
                this.render();
                this.dispatchEvent(new CustomEvent('close', {bubbles: false, cancelable: false}));
                // enable tabindex for all elements
                document.dispatchEvent(new CustomEvent('a11y.toggletabindex', {
                    detail: {enable: document.body}
                }));
            }
        });
    }
});
